import { format, isToday, isYesterday } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';

/** Converte hex `#rrggbb` (cor de categoria vinda do dado) em rgba com transparência. */
export const hexToRgba = (hex: string, alpha: number): string => {
  const limpo = hex.trim().replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(limpo)) return hex;
  const numero = parseInt(limpo, 16);
  const r = (numero >> 16) & 255;
  const g = (numero >> 8) & 255;
  const b = numero & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/** Valor monetário curto, sem centavos — para espaços apertados (metas, eixos). */
export const valorCurto = (valor: number): string =>
  valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

/** Data curta pt-BR: 'hoje', 'ontem' ou '12 mai'. */
export const dataCurta = (data: Date): string => {
  if (isToday(data)) return 'hoje';
  if (isYesterday(data)) return 'ontem';
  return format(data, 'd MMM', { locale: ptBR }).replace('.', '');
};
